export default "__VITE_ASSET__tu$8KMbJ__"